import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../../entraConfig';

const msalInstance = new PublicClientApplication(msalConfig);

await msalInstance.initialize();
msalInstance.enableAccountStorageEvents();

export default msalInstance;
